module.exports = __webpack_public_path__ + "img/04_full.f75509bc.jpg";